import React, { useEffect } from "react";
import moment from "moment";
import { filterPayType, filterTree, filterOnAccount } from "../../../utils/decoder"

import { Button, Drawer, Form, Input, Select } from "antd";
import { useModel } from "../../../models";
import { debounce } from "lodash";

const layout = {
    labelCol: {
        span: 6,
    },
    wrapperCol: {
        span: 18,
    },
};
const tailLayout = {
    wrapperCol: {
        offset: 6,
        span: 18,
    },
};

const AreaForm = () => {
    const [form] = Form.useForm();
    const [{ payTypeDict },] = useModel("cmDict");
    const [
        { selectedDocument, },
        {
            settle,
            setPaymentDrawerVisible,
            loadPo,
        }
    ] = useModel("purchasePo");

    useEffect(() => {
        const payDate = moment().format("YYYY-MM-DD");
        const {
            purchaseCode,
            createTime,
            supplierCode,
            supplierName,
            payableAmount,
            paidAmount = 0,
            paymentMethod
        } = selectedDocument;


        form.setFieldsValue({
            purchaseCode,
            createTime,
            supplierCode,
            supplierName,
            payableAmount,
            paidAmount,
            payType: paymentMethod,
            payDate,
        });
        /*form.setFieldsValue({createTime: selectedDocument.createTime});
        form.setFieldsValue({supplierCode: selectedDocument.supplierCode});
        form.setFieldsValue({supplierName: selectedDocument.supplierName});
        form.setFieldsValue({payDate: moment().format("YYYY-MM-DD")});
        form.setFieldsValue({payableAmount: selectedDocument.payableAmount});
        form.setFieldsValue({paidAmount: selectedDocument.paidAmount});
        form.setFieldsValue({payType: selectedDocument.paymentMethod});//支付方式*/
    }, [selectedDocument]);


    const onFinish = debounce(() => {
        form.validateFields().then(data => {
            const { payType, payDesc } = data;
            settle({
                showMsg: true,
                data: {
                    id: selectedDocument.id,
                    payTypeCode: payType,
                    payDesc,
                }
            }).then(ret => {
                if (ret) {
                    /*setSelectedDocument({
                        ...selectedDocument,
                        paidAmount: selectedDocument.payableAmount,
                        paymentMethod: form.getFieldValue("payType")
                    });*/
                    setPaymentDrawerVisible(false);
                    const { id } = selectedDocument;
                    loadPo({ showMsg: true, data: id }).then(_ => _)
                }
            });
        })
    }, 600)

    const onClose = () => {
        setPaymentDrawerVisible(false)
    }
    return (
        <Form {...layout} form={form} name="control-hooks"
            onFinish={onFinish}>
            <Form.Item name="purchaseCode" label="采购单号">
                <Input disabled={true} />
            </Form.Item>
            <Form.Item name="createTime" label="制单日期">
                <Input disabled={true} />
            </Form.Item>
            <Form.Item name="supplierCode" label="供应商编码">
                <Input disabled={true} />
            </Form.Item>
            <Form.Item name="supplierName" label="供应商名称">
                <Input disabled={true} />
            </Form.Item>
            <Form.Item name="payDate" label="结算日期">
                <Input disabled={true} />
            </Form.Item>
            <Form.Item name="payableAmount" label="应付金额">
                <Input disabled={true} />
            </Form.Item>
            <Form.Item name="paidAmount" label="已付金额">
                <Input disabled={true} />
            </Form.Item>
            <Form.Item name="payType" label="支付方式" rules={[{ required: true, message: '请选择支付方式', }]}>
                <Select
                    showSearch
                    allowClear={true}
                    placeholder="选择支付方式"
                    filterOption={(input, option) => option.label.indexOf(input) >= 0}
                    // 张家口
                    options={filterOnAccount(payTypeDict)}
                // 公司潍柴
                // options={payTypeDict}

                />
            </Form.Item>
            <Form.Item name="payDesc" label="备注" rules={[{ required: false }]}>
                <Input.TextArea />
            </Form.Item>
            <Form.Item {...tailLayout}>
                <Button type="primary" htmlType="submit">
                    确定
                </Button>
                <Button htmlType="button" onClick={onClose} className="margin-left-8">
                    取消
                </Button>
            </Form.Item>
        </Form>
    );
}
export default function () {
    const [{ paymentDrawerVisible }, { setPaymentDrawerVisible }] = useModel("purchasePo");
    return (
        <Drawer
            title="采购付款"
            placement="right"
            width={500}
            closable={true}
            onClose={() => {
                setPaymentDrawerVisible(false)
            }}
            visible={paymentDrawerVisible}
        >
            <AreaForm />
        </Drawer>
    )
}